<div class="game-dashboard-block games-list" brtBorderGradient>
  <div class="games-list__headline">
    <brt-dashboard-boxes-head [data]="headlineData"></brt-dashboard-boxes-head>
  </div>


  <div class="games-list__grid">
    <ng-container *ngIf="games.length > 0; else placeholders">
      <div class="games-list__grid-item" *ngFor="let game of games">
        <brt-game-preview [data]="game"></brt-game-preview>
      </div>
    </ng-container>
    <ng-template #placeholders>
      <div class="games-list__grid-item" *ngFor="let game of [].constructor(3)">
        <img class="skeleton-desktop" src="/assets/img/game-ITEM.svg" alt="">
        <img class="skeleton-mobile" src="/assets/img/game-mobile-ITEM.svg" alt="">
      </div>
    </ng-template>

  </div>
</div>
